import * as angular from "angular";
import {IController, IScope} from "angular";

export class branchesTableRowCtrl implements IController {

  id: string;
  allowSelect: boolean;
  isSelected: boolean;
  onToggleSelect: Function;

  /* @ngInject */
  constructor(private $branches, private $scope: IScope) {
  }

  $onInit() {
    if (this.id) {
      this.$branches(this.id).$bindCtrlToId(this.$scope, this, 'branch', 'id');
    }
  }

  $onChanges(changes) {
    if (changes.id && !changes.id.isFirstChange()) {
      this.$onInit();
    }
  }

}

angular
  .module('bringoz.admin.branches')
  .component('branchesTableRow', {
    require: {
      branchesTableCtrl: '^branchesTable'
    },
    bindings: {
      id: '<',
      allowSelect: '<?',
      isSelected: '<?',
      onToggleSelect: '&'
    },
    template: require('./branches-table-row.html').default,
    controller: branchesTableRowCtrl
  });
